const DATE_INPUT_VALUE_PATTERN = /^\d{4}-\d{2}-\d{2}/;

export const getCfcCollectionDateMaximum = (deadline: string): string =>
  deadline.match(DATE_INPUT_VALUE_PATTERN)?.[0] ?? "";

export const isCfcCollectionDateAfterDeadline = (
  collectionDate: string,
  deadline: string,
): boolean => {
  const maximum = getCfcCollectionDateMaximum(deadline);
  return Boolean(collectionDate && maximum && collectionDate > maximum);
};
